import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { Box, Typography, Chip } from "@mui/material";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { dashboardColors, isDashboardDark } from "./dashboardTheme";

const ChartDonut = (props) => {
  const { title, value, data, color } = props;
  const theme = useTheme();
  const isDark = isDashboardDark(theme);

  const data1 = JSON.parse(`[${String(data).replace(/'/g, '"')}]`);
  const colors = Array.isArray(color) ? color : [color];
  const displayValue = value ?? 0;

  const { text: labelColor, textSoft: subLabelColor } = dashboardColors(isDark);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ position: "relative", width: "100%", height: 240 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data1}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={88}
              innerRadius={58}
              paddingAngle={data1.length > 1 ? 4 : 0}
              strokeWidth={0}
            >
              {data1.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            pointerEvents: "none",
          }}
        >
          <Typography
            variant="caption"
            sx={{ color: subLabelColor, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}
          >
            {title}
          </Typography>
          <Typography variant="h4" sx={{ color: labelColor, fontWeight: 700, lineHeight: 1.1 }}>
            {displayValue}%
          </Typography>
        </Box>
      </Box>
      {data1.length > 1 && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, justifyContent: "center", mt: 1 }}>
          {data1.map((entry, index) => (
            <Chip
              key={entry.name}
              size="small"
              label={entry.name}
              sx={{
                bgcolor: `${colors[index % colors.length]}22`,
                color: colors[index % colors.length],
                fontWeight: 600,
                fontSize: "0.7rem",
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ChartDonut;
